(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();

(function (Hotjar, Config, $) {
    'use strict';

    Hotjar.callTrigger = function (label) {
        hj('trigger', label);
    }

    Hotjar.startRecording = function (tag) {
        hj('trigger', Config.HotjarRecordingTrigger);
        if (tag) {
            Hotjar.tagRecording(tag);
        }
    }

    Hotjar.tagRecording = function (tag) {
        try {
            hj && hj('tagRecording', tag);
        }
        catch (e) {}
        
    }

})(LN.Hotjar, LN.Config, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/hotjar.js